import { ReactNode } from "react";
import { Row } from "@narmi/design_system";
import { InformationRequest } from "./CaseDetailDrawer";

export function formatInformationRequest(request: InformationRequest) {
  let irType;
  switch (request.kind) {
    case "missing":
      irType = "Missing information";
      break;
    case "incorrect":
      irType = "Incorrect information";
      break;
    case "duplicate":
      irType = "Duplicate instruction";
  }
  const resolutionInfo: Array<ReactNode> = [];
  if (request.resolution) {
    switch (request.resolution) {
      case "NINF":
        resolutionInfo.push(
          <Row key="resolution">
            <Row.Item>No further information (NINF)</Row.Item>
          </Row>
        );
        break;
      case "INFO":
        resolutionInfo.push(
          <Row key="resolution">
            <Row.Item>Additional payment information sent (INFO):</Row.Item>
          </Row>
        );
        if (request.additional_payment_information !== null) {
          const additionalPaymentInformation = request.additional_payment_information;
          resolutionInfo.push(
            <Row key="additional">
              <Row.Item>
                <ul>
                  {Object.keys(additionalPaymentInformation).map((k: string) => {
                    if (additionalPaymentInformation[k] === null) {
                      return null;
                    } else if (k === "remittance_info") {
                      if ((additionalPaymentInformation[k] as any)["unstructured"]) {
                        return `${k}: ${(additionalPaymentInformation[k] as any)["unstructured"]}`;
                      }
                      return `${k}: ${JSON.stringify((additionalPaymentInformation[k] as any)["structured"])}`;
                    }
                    return `${k}: ${additionalPaymentInformation[k]}`;
                  })}
                </ul>
              </Row.Item>
            </Row>
          );
        }
        break;
      case "IPAY":
        resolutionInfo.push(
          <Row>
            <Row.Item>Additional payment sent (IPAY)</Row.Item>
          </Row>
        );
        if (request.corrective_payment_identification !== "") {
          resolutionInfo.push(
            <Row key="additional">
              <Row.Item>
                <a target="_blank" href={`payments/${request.corrective_payment_identification}`}>
                  Payment link
                </a>
              </Row.Item>
            </Row>
          );
        }
        break;
      case "IDUP":
        // we should get end to end id, or unique e2e reference, or
        // transaction id when we get this. BUT, none of those is the
        // same as a payment id. On the backend we'd need to correlate
        // in order to provide a link to the original
        resolutionInfo.push(
          <Row>
            <Row.Item>Instruction is duplicate (IDUP)</Row.Item>
          </Row>
        );
        break;
    }
  }

  if (resolutionInfo.length !== 0) {
    resolutionInfo.unshift(
      <Row key="res_header">
        <div className="fontWeight--bold padding--top--s margin--top--s">Resolution:</div>
      </Row>
    );
  }

  return (
    <>
      <div>{irType}</div>
      {request.aml ? <div>Anti-money laundering investigation</div> : null}
      {request.narrative ? <div>{request.narrative}</div> : null}
      {resolutionInfo}
    </>
  );
}
